import {
  defaultFeatureToggleConfig,
  defaultIDMFeatureToggleConfig,
} from '@infield/features/app-config/default-config';
import type { RootLocationFeatureToggles } from '@infield/features/app-config/types';
import { useContext } from 'react';

import { getFeatureToggleConfigContext } from './use-feature-toggle-config-context';

export const useFeatureToggleConfig = (
  rootLocationExternalId: string
): {
  config: Record<string, boolean> | RootLocationFeatureToggles | undefined;
  isLoading: boolean;
} => {
  const { useAppConfigContext, useInFieldLocationConfig } = useContext(
    getFeatureToggleConfigContext()
  );

  const { location, isIdm } = useAppConfigContext();
  const { data: infieldLocationConfig, isLoading } = useInFieldLocationConfig(
    rootLocationExternalId
  );

  if (isIdm) {
    return {
      config: (location?.featureToggles ??
        defaultIDMFeatureToggleConfig) satisfies RootLocationFeatureToggles,
      isLoading,
    };
  }

  return {
    config: (infieldLocationConfig?.featureToggles ??
      defaultFeatureToggleConfig) satisfies RootLocationFeatureToggles,
    isLoading,
  };
};
